module.exports = __webpack_public_path__ + "img/apple-btn.00299b65.png";